(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSecureGroupList(
    $ngBootbox, toastr, $filter, GroupListService, GroupModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/secureSettings/secureGroupList/secureGroupList.template.html',
      link: function(scope) {


        (function() {
          setGroupList();
        })();

        function setGroupList () {
          scope.groupList = [];
          var groups = scope.tenant.info._embedded.securePrintConfiguration._embedded[scope.context.groups];
          angular.forEach(groups, function (group) {
            var newGroup = new GroupModel(group);
            scope.groupList.push(newGroup);
          });
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        scope.openListMenu = function (event, queue) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = queue;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'nestedGroupList',
              scrollContainerId: 'GroupScrollContainer'
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (group, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'REMOVE_GROUP':
              scope.removeGroup(group);
            break;
          }
        }

        scope.removeGroup = function(group) {
          var url = scope.tenant.info._embedded.securePrintConfiguration._links[scope.context.link].href;
          var postObjectRemove = {
            type: 'DELETE',
            groups: [group.info._links.self.href]
          }

          if (scope.context.securityLevel) {
            url = url.replace('{securityLevel}', scope.context.securityLevel);
            postObjectRemove.securityLevel = scope.context.securityLevel
          }

          var postObjectWrapper = [];

          postObjectWrapper.push(postObjectRemove);

          GroupListService.addSecuritySettingOnGroups(url, postObjectWrapper).then(function() {
            toastr.success($filter("translate")("ChangesSaved"));
            removeGroupFromList(group);
          }).catch(function(error){
            toastr.error($filter("translate")("ERROR"));
          });
        };

        function removeGroupFromList (group) {
          for (var i = 0; i < scope.groupList.length; i++) {
            if (group.info._links.self.href === scope.groupList[i].info._links.self.href) {
              scope.groupList.splice(i, 1);
              break;
            }
          }
        }

        scope.addGroups = function (event) {
          scope.callback({context:
            {
              groups : scope.context.groups,
              link: scope.context.link,
              event: event,
              type: 'addSecureGroups',
              bypassCloseOutside: true,
              dontUseTitle: false,
              dontUseName: true,
              exclude: scope.context.exclude,
              securityLevel: scope.context.securityLevel ?  scope.context.securityLevel : null,
              title: 'AddGroups',
              name: scope.context.name}});
        }

        scope.removeGroups = function (event) {
          scope.callback({context:
            {
              groups : scope.context.groups,
              link: scope.context.link,
              event: event,
              type: 'removeSecureGroups',
              dontUseTitle: false,
              dontUseName: true,
              securityLevel: scope.context.securityLevel ?  scope.context.securityLevel : null,
              title: 'RemoveGroups',
              name: scope.context.name}});
        }

      }
    };
  }

  pxSecureGroupList.$inject = ['$ngBootbox', 'toastr', '$filter', 'GroupListService', 'GroupModel'];

  angular
    .module('printix-admin')
    .directive('pxSecureGroupList', pxSecureGroupList);

})();
